<template>
  <!-- 选择急救车弹框 -->
  <my-dialog-form
    form-title="新增事例"
    :dialog-form-visible="isShowAddMission"
    :width="844"
    @confirmOk="confirmBtn"
  >
    <template #body>
      <el-form ref="ruleForm" :model="ruleForm" label-position="left">
        <el-form-item>
          <el-row>
            <ul class="car-options">
              <el-radio-group v-model="ruleForm.ambulanceId" size="mini">
                <li
                  v-for="item in carOptions"
                  :key="item.value"
                >
                  <el-radio
                    v-model="ruleForm.ambulanceId"
                    :disabled="carDisabled[item.value]"
                    :label="item.value"
                  >
                    {{ item.label }}
                  </el-radio>

                </li>
              </el-radio-group>
            </ul>
          </el-row>
        </el-form-item>
        <div class="add-options">
          <div class="first-row">
            <el-form-item label="姓名：" label-width="90px" class="form-name">
              <el-input v-model="ruleForm.name"/>
            </el-form-item>
            <el-form-item label="年龄：" label-width="65px" class="form-age inline-form">
              <el-input v-model="ruleForm.age"/>
              <el-select v-model="ruleForm.ageUnit" placeholder="请选择">
                <el-option
                  v-for="item in ageOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="性别：" label-width="65px" class="form-gender inline-form">
              <el-select v-model="ruleForm.gender" placeholder="请选择">
                <el-option
                  v-for="item in genderOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
            </el-form-item>
          </div>
          <el-form-item label="联系电话：" label-width="90px" class="form-phone">
            <el-input v-model="ruleForm.phoneNumber"/>
          </el-form-item>
          <el-form-item label="地址：" label-width="90px" class="form-addr">
            <!--            <el-input v-model="addCarForm.patientAddr"/>-->
            <el-autocomplete
              v-model="ruleForm.patientAddr"
              :fetch-suggestions="querySearchAsync"
              placeholder="请输入内容"
              style="width: 450px;"
              @select="handleSelect"
            />
          </el-form-item>
          <el-form-item label="主诉：" label-width="90px" class="form-main">
            <el-input v-model="ruleForm.mainComplaint"/>
          </el-form-item>
        </div>
      </el-form>
    </template>
  </my-dialog-form>
</template>

<script>
import MyDialogForm from "@components/customDialog/MyDialogForm";
import { mapState } from "vuex";
import { SearchNeighbour } from "@/utils/basic";
import { addPatient } from "@api/hospitalList";
import { showWindowMessage } from "@utils/notification";

export default {
  name: "AddNewMission",
  components: { MyDialogForm },
  props: {
    isShowAddMission: {
      type: Boolean,
      default: false
    },
    carDisabled: {
      type: Object,
      default() {
        return {};
      }
    },
  },
  emits: ["dealAddPatientInfo"],
  data() {
    return {
      carOptions: [],
      ageOptions: ["岁", "周"],
      genderOptions: ["男", "女"],
      ruleForm: { // 添加急救病人 表单
        name: "",
        age: "",
        ageUnit: "",
        gender: "",
        patientAddr: "",
        mainComplaint: "",
        ambulanceId: "",
        hospitalId: "",
        phoneNumber: "",
        method: "",
      },
    };
  },
  computed: {
    ...mapState({
      hospitalID: "hospitalID",
      userInfo: "userInfo",
      ambulanceLists: "ambulanceLists",
      webSocketClient: "webSocketClient"
    })
  },
  mounted() {
    this.getCarList();
  },

  methods: {
    handleSelect(val) {
      console.log(val);
    },
    async querySearchAsync(queryString, cb) {
      if (queryString === "") {
        return;
      }
      let results = await SearchNeighbour(queryString);
      results = results.tips;
      results.forEach(item => {
        const { district, name } = item;
        item.value = `${district}${name}`;
      });
      cb(results);
    },
    getCarList() {
      // 从store中获得carList供后续选择
      this.ambulanceLists.forEach((ele) => {
        const carName = ele.name + "(" + ele.idName + ")";
        this.carOptions.push({ value: ele.id, label: carName });
      });
    },
    async confirmBtn(e) {
      // 监听到子组件的点击确定按钮 ||添加急救车事件
      if (e === "confirm") {
        try {
          this.ruleForm.hospitalId = this.hospitalID;
          this.ruleForm.method = "addMedicalhistory";
          const { msg } = await addPatient(this.ruleForm);
          this.isShowSmallDialog = true;
          this.showSmallDialogMessage = msg;
          this.webSocketClient.send(JSON.stringify({
            type: "activeMedicalhistoryAll",
            token: this.userInfo.token
          }));
          this.closeAddDialog();
        } catch (e) {
          showWindowMessage(3, e, this);
        }
      } else {
        this.closeAddDialog();
      }
    },
    closeAddDialog() {
      Object.keys(this.ruleForm).forEach(item => {
        this.ruleForm[item] = "";
      });
      this.$emit("dealAddPatientInfo");
    }
  }
};
</script>

<style scoped lang="scss">
.el-radio-group ::v-deep {
  list-style: none;
  display: flex;

  font-size: 16px;
  color: #2AA5E3;
  flex-wrap: wrap;

  li {
    margin-right: 55px;
  }

  .el-radio.is-checked {
    .el-radio__label {
      color: #2AA5E3;
    }

    .el-radio__inner {
      background: #2AA5E3;
      border-color: #2AA5E3;
    }

  }
}

.add-options ::v-deep {
  background: #F0F5F7;
  border-radius: 10px;
  padding: 24px;

  .first-row {
    display: flex;
  }

  .form-name {
    .el-input {
      width: 120px;
    }
  }

  .form-age {
    .el-select {
      margin-left: 16px;
    }

    .el-form-item__content {
      width: 176px;
    }
  }

  .inline-form {
    .el-input,
    .el-select {
      width: 80px;
    }

    label {
      margin-left: 50px;
    }

    .el-form-item__content {
      margin-left: 115px !important;
    }
  }

  .form-phone {
    .el-input {
      width: 232px;
    }
  }

  .form-addr,
  .form-main {
    .el-input {
      width: 606px;
    }
  }

  .el-input__inner {
    height: 32px;
    border: 1px solid #999999;
    border-radius: 10px;
  }

}
</style>
